export function removeNNVariantDisplayName(displayName: string) {
  return displayName.replace(/(\(.*\))/g, '');
}

export function getNNVariantName(displayName: string) {
  const matchesDisplayName = /(\(.*\))/g.exec(displayName) || [];
  const matchesBaseName = /\d+_(\w+)$/g.exec(displayName) || [];
  return (matchesDisplayName[0] || matchesBaseName[1] || '').replace(
    /\(|\)/g,
    '',
  );
}

export function getNNIterationNumber(displayName: string) {
  const matches = /((#\d+)|(_\d+))/g.exec(displayName) || [''];
  return Number(matches[0].replace(/#|_/g, ''));
}

export function getNNPrefix(baseName: string) {
  const matches = /(^\w+_\d+_)/g.exec(baseName) || [''];
  return matches[0];
}

export function splitNNVariantDisplayName(displayName: string) {
  const variant = getNNVariantName(displayName);
  const iteration = getNNIterationNumber(displayName);
  return { variant, variantLower: variant.toLowerCase(), iteration };
}
